import { createContext } from 'react';

const Context = createContext<[void, any]>([, {}]);

export default Context;
